import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import { Alert, SlideOver } from 'lynkco-up-core';

import { PageHeading, ActionPanel } from '../../components';
import { usePanelResize } from '../../hooks';
import { DeleteUserDataContent, GetUserDataContent } from '../../parts/GDPR';

enum OperationType {
  GET_USER_DATA = 'GET_USER_DATA',
  DELETE_USER_DATA = 'DELETE_USER_DATA',
  NONE = 'NONE',
}

function Gdpr() {
  const [isSlideOverOpen, setSlideOverOpen] = useState(false);
  const [operationType, setOperationType] = useState(OperationType.NONE);
  const slideOverSize = usePanelResize();

  function handleOpenGetUserData() {
    setOperationType(OperationType.GET_USER_DATA);
    setSlideOverOpen(true);
  }

  function handleOpenDeleteUserData() {
    setOperationType(OperationType.DELETE_USER_DATA);
    setSlideOverOpen(true);
  }

  function handleCloseSlideOver() {
    setSlideOverOpen(false);
  }

  useEffect(() => {
    if (!isSlideOverOpen) {
      setOperationType(OperationType.NONE);
    }
  }, [isSlideOverOpen]);

  return (
    <div>
      <Helmet>
        <title>GDPR - Verification Operations</title>
      </Helmet>
      <PageHeading title="GDPR requests" description="Delete or get customer data" />
      <div className="pt-7 px-7">
        <Alert
          type="info"
          heading="Verification data can be extracted or deleted by flow"
          body="Use the verification selector to work with Car Sharing, Identity Verification, or all Onfido verification data."
        />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-1 gap-7 p-7">
        <ActionPanel
          title="Get user data"
          description="Get Onfido verification data for one flow or all flows. Connected Services extraction remains separate."
          buttonText="Get started"
          onClick={handleOpenGetUserData}
          iconName={'person'}
          iconBg={'bg-blue-500'}
        />
        <ActionPanel
          title="Delete user data"
          description="Delete Onfido verification data for one flow or all flows. Connected Services deletion remains separate."
          buttonText="Get started"
          onClick={handleOpenDeleteUserData}
          iconName={'person_remove'}
          iconBg={'bg-red-500'}
        />
      </div>
      <SlideOver
        isOpen={isSlideOverOpen && operationType === OperationType.GET_USER_DATA}
        onCancel={handleCloseSlideOver}
        onClose={handleCloseSlideOver}
        size={slideOverSize}>
        <GetUserDataContent />
      </SlideOver>
      <SlideOver
        isOpen={isSlideOverOpen && operationType === OperationType.DELETE_USER_DATA}
        onCancel={handleCloseSlideOver}
        onClose={handleCloseSlideOver}
        size={slideOverSize}>
        <DeleteUserDataContent />
      </SlideOver>
    </div>
  );
}

export default Gdpr;
